import React, { useContext, useState, useEffect } from "react";
import { get, isEmpty } from "lodash";
import { Row, Col, Form } from "react-bootstrap";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import {
  ManagePlanLayout,
  FieldButtonGroup,
  FieldInputDollar,
  AddHierarchy,
  LoaderWrapper,
} from "../../../components";
import {
  MANAGE_PLAN_ROUTES,
  ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  yesNoOptions,
  required,
  getAdvancedPathWithParam,
  getPathWithParam,
} from "../../../utils";
import {
  createPlanStore,
  setManagePageLevelData,
  setManagePlanFlow,
  setManagePlanToastInfo,
  savePlanDetailsAction,
} from "../../../contexts";
import { getRollOver, listSource, saveRollOver } from "../../../services";
import { useRouterParams, useRequest } from "../../../abstracts";

const RolloverContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const { planId, flow } = useRouterParams();
  const [newFlow, setNewFlow] = useState("");
  const formName = managePlanFormNames.ADD_ROLLOVERS;
  const fields = formFields[formName];
  const [rolloverId, setRolloverId] = useState(0);
  useEffect(() => {
    if (planId) {
      getRollOver(parseInt(planId)).then((res) => {
        if (res.isSuccessful) {
          dispatch(
            setManagePlanFlow({
              rollover: get(res, "rollover", []),
            })
          );
        }
        setRolloverId(res?.rollover?.id ?? 0);
      });
    }
  }, []);
  const { response: data, loading: load } = useRequest({
    method: listSource,
    payload: parseInt(planId),
    defaultResponse: [],
  });
  const rolloverData = get(state, "rollover", []);
  const rollOverSourcesData = get(data, "employerSourcesList", []).filter(
    (x) => x.sourceCategory == 4
  );

  const buttons = [
    {
      link: getAdvancedPathWithParam({
        path: MANAGE_PLAN_ROUTES.ROLLOVER,
        pathParam: [FLOW_TYPES.EDIT, planId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: ROUTES.PLAN,
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => {
        //setNewFlow(FLOW_TYPES.SAVE);
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.ROLLOVER,
            pathParam: [FLOW_TYPES.SAVE, planId],
          })
        );
      },
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];
  const approvalHierarchy = [
    {
      order: 1,
      userRole: 1,
      approval: false,
    },
    {
      order: 2,
      userRole: 2,
      approval: false,
    },
  ];
  const [apiLoading, setApiLoading] = useState(false);
  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    let objectKeys = Object.keys(values);
    let requestObject = {};
    objectKeys.forEach((key) => {
      if (
        (values[key] !== null && values[key] !== undefined) ||
        values[key] === false
      ) {
        requestObject[key] = values[key];
      }
    });
    setApiLoading(true);
    saveRollOver({
      ...requestObject,
      planId: planId,
      approvalHierarchy: values["approvalHierarchy"]
        ? values["approvalHierarchy"].map((item) => {
            return {
              order: item.order,
              userRole: item.userRole,
              approval: item.approval,
              id: item.id ? item.id : 0,
            };
          })
        : [],
    }).then((response) => {
      setApiLoading(false);

      if (response.isSuccessful) {
        dispatch(
          setManagePlanFlow({
            rollover: get(response, "rollover", []),
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: `Data saved successfully`,
          })
        );
        //setNewFlow(FLOW_TYPES.EDIT);
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.ROLLOVER,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
      } else {
        setSubmitting(false);
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
    });
  };

  const initialValues = {
    [fields.rollOversAllowed]: false,
    [fields.rollOversAllowedPriorToDistribution]: false,
    [fields.rollOversAllowedPriorToLoans]: false,
    [fields.rollOversAllowedPriorToEligibility]: true,
  };
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...rolloverData,
        approvalHierarchy:
          rolloverData != null && !isEmpty(rolloverData.approvalHierarchy)
            ? rolloverData.approvalHierarchy
            : approvalHierarchy,
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          values,
          ...rest
        } = formProps;
        return (
          <LoaderWrapper isLoading={load || apiLoading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManagePlanLayout buttons={buttons} pageFlow={newFlow || flow}>
                <Row>
                  <Col>
                    <Field
                      isRequired
                      size="sm"
                      name={fields.rollOversAllowed}
                      label={"Rollovers allowed?"}
                      options={yesNoOptions}
                      selectedValue={values[fields.rollOversAllowed]}
                      value={values[fields.rollOversAllowed]}
                      onChange={(value) => {
                        setFieldValue(fields.rollOversAllowed, value);
                      }}
                      component={FieldButtonGroup}
                      validate={required}
                      disabled={isEdit && !isSave}
                    />
                  </Col>
                </Row>

                {values[fields.rollOversAllowed] === true ? (
                  <>
                    {/* <Row>
                    <Col>
                      <Field
                        isRequired
                        size="sm"
                        name={fields.rollOversAllowedPriorToEligibility}
                        label={"Rollover prior to eligibility allowed?"}
                        options={yesNoOptions}
                        selectedValue={
                          values[fields.rollOversAllowedPriorToEligibility]
                        }
                        value={
                          values[fields.rollOversAllowedPriorToEligibility]
                        }
                        onChange={(value) => {
                          setFieldValue(
                            fields.rollOversAllowedPriorToEligibility,
                            value
                          );
                        }}
                        component={FieldButtonGroup}
                        validate={required}
                        disabled={isEdit && !isSave}
                      />
                    </Col>
                  </Row> */}

                    {/* <Row>
                    <Col>
                      <Field
                        isRequired
                        size="sm"
                        name={fields.rollOversAllowedPriorToDistribution}
                        label={"Distribution prior to eligibility allowed?"}
                        options={yesNoOptions}
                        selectedValue={
                          values[fields.rollOversAllowedPriorToDistribution]
                        }
                        value={
                          values[fields.rollOversAllowedPriorToDistribution]
                        }
                        onChange={(value) => {
                          setFieldValue(
                            fields.rollOversAllowedPriorToDistribution,
                            value
                          );
                        }}
                        component={FieldButtonGroup}
                        validate={required}
                        disabled={isEdit && !isSave}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Field
                        isRequired
                        size="sm"
                        name={fields.rollOversAllowedPriorToLoans}
                        label={"Loans prior to eligibility allowed?"}
                        options={yesNoOptions}
                        selectedValue={
                          values[fields.rollOversAllowedPriorToLoans]
                        }
                        value={values[fields.rollOversAllowedPriorToLoans]}
                        onChange={(value) => {
                          setFieldValue(
                            fields.rollOversAllowedPriorToLoans,
                            value
                          );
                        }}
                        component={FieldButtonGroup}
                        validate={required}
                        disabled={isEdit && !isSave}
                      />
                    </Col>
                  </Row> */}
                    <Row>
                      <Col>
                        <Field
                          size="xs"
                          isRequired
                          name={fields.rollOversFee}
                          label={"Rollover amount fee"}
                          component={FieldInputDollar}
                          type="number"
                          autoComplete="off"
                          value={values[fields.rollOversFee]}
                          onChange={handleChange}
                          disabled={isEdit && !isSave}
                          min={0}
                          max={999.99}
                        />
                      </Col>
                    </Row>
                    <div>
                      <p style={{ fontSize: "12px", marginBottom: "6px" }}>
                        Available rollover source
                      </p>
                      <p style={{ fontSize: "14px", lineHeight: "21px" }}>
                        {!isEmpty(rollOverSourcesData)
                          ? rollOverSourcesData.map((item, index) => {
                              return (
                                <p>{item.sourceName}</p>
                                // +(index == rollOverSourcesData.length - 2
                                //   ? " and "
                                //   : index == rollOverSourcesData.length - 1
                                //   ? ""
                                //   : ", ")
                              );
                            })
                          : "No Available Sources found"}
                      </p>
                    </div>
                    <AddHierarchy
                      {...formProps}
                      fields={fields}
                      isEdit={isEdit}
                      isSave={isSave}
                      setValues={setValues}
                      values={values}
                    />
                  </>
                ) : null}
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default RolloverContainer;
